import { Component, OnInit, ViewEncapsulation } from '@angular/core'
import { Helpers } from '../../../helpers'

@Component({
  encapsulation: ViewEncapsulation.None,
  selector: '.m-grid.m-grid--hor.m-grid--root.m-page',
  templateUrl: './layout.component.html'
})
export class LayoutComponent implements OnInit {
  constructor () {}
  public ngOnInit () {}
}
